import React from 'react';
import apiClient from '../../apiClient';
import { withRouter } from 'react-router-dom';
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@material-ui/core';

class LocationDetails extends React.Component {
  state = {
    locationList: [],
    selectedLocationId: '',
    details: [],
    errorMessage: null,
  };

  componentDidMount() {
    const user = JSON.parse(sessionStorage.getItem('user'));
    const accessToken = user && user.accessToken ? user.accessToken : '';

    apiClient
      .get('/api/get/itemlocation', { headers: { Authorization: `Bearer ${accessToken}` } })
      .then((res) => {
        this.setState({ locationList: res.data || [] });
      })
      .catch(() => {
        this.setState({ errorMessage: 'Could not load locations.' });
      });
  }

  handleLocationChange = (e) => {
    const locationId = e.target.value;
    this.setState({ selectedLocationId: locationId, details: [], errorMessage: null });
    if (locationId === '' || locationId == null) {
      return;
    }

    const user = JSON.parse(sessionStorage.getItem('user'));
    const accessToken = user && user.accessToken ? user.accessToken : '';
    apiClient
      .get('/api/get/locationdetails', {
        params: { locationId },
        headers: { Authorization: `Bearer ${accessToken}` },
      })
      .then((res) => {
        this.setState({ details: res.data || [] });
      })
      .catch(() => {
        this.setState({ errorMessage: 'Could not load location details.' });
      });
  };

  render() {
    return (
      <div className="ItemCategory">
        <h2>Location Details</h2>
        <div style={{ display: "flex", justifyContent: "space-between", marginTop: "20px" }}>
          <div className="alignDiv" style={{ minWidth: 360 }}>
            <FormControl fullWidth>
              <InputLabel id="location-details-dropdown-label">Location</InputLabel>
              <Select
                labelId="location-details-dropdown-label"
                value={this.state.selectedLocationId}
                onChange={this.handleLocationChange}
              >
                <MenuItem value="">
                  <em>Select Location</em>
                </MenuItem>
                {this.state.locationList.map((loc) => (
                  <MenuItem key={loc.ItemLocationId} value={loc.ItemLocationId}>
                    {loc.LocationName}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
        </div>

        <div style={{ marginTop: "10px" }}>
          <Table size="small" aria-label="location details table">
            <TableHead>
              <TableRow>
                <TableCell align="center">Counter</TableCell>
                <TableCell align="left">Item Number + Item Name</TableCell>
                <TableCell align="right">Quantity</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {this.state.details.map((row, idx) => (
                <TableRow key={`${row.ItemId}-${idx}`}>
                  <TableCell align="center">{idx + 1}</TableCell>
                  <TableCell>{`${row.ItemNumber || ''} - ${row.ItemName || ''}`}</TableCell>
                  <TableCell align="right">{Number(row.Quantity || 0).toFixed(2)}</TableCell>
                </TableRow>
              ))}
              {!this.state.details.length ? (
                <TableRow>
                  <TableCell colSpan={3}>
                    <Typography variant="body2" color="textSecondary">
                      Select a location to view details.
                    </Typography>
                  </TableCell>
                </TableRow>
              ) : null}
            </TableBody>
          </Table>
          {this.state.errorMessage ? (
            <div style={{ backgroundColor: '#FF7F7F', color: '#fff', padding: '10px', marginTop: '10px' }}>
              {this.state.errorMessage}
            </div>
          ) : null}
        </div>
      </div>
    );
  }
}

export default withRouter(LocationDetails);
